import { Grid, Stack, Typography } from '@mui/joy';
import { PencilSimple } from '@phosphor-icons/react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { UpsertProject } from 'projects/components';
import { ProjectType } from 'projects/constants';
import { IProjectDetails } from 'projects/types';
import { Direction, Level } from 'theme/enums';

import { Duration, Location, MainInfo, PipelineInformation } from './sections';

interface IProps {
  project: IProjectDetails;
}

export const BaseInformation = ({ project }: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const isDtdProject = useMemo(() => {
    return project.type === ProjectType.DAY_TO_DAY;
  }, [project.type]);

  const isEditable = useMemo(() => {
    return !isDtdProject;
  }, [isDtdProject]);

  const { t } = useTranslation();

  return (
    <Stack sx={{ padding: '24px 0' }}>
      <Stack direction={Direction.ROW} justifyContent="space-between">
        <Typography level={Level.H4}>{t('titleBaseInformation')}</Typography>
        {isEditable && (
          <Button
            text={t('buttonLabelEdit')}
            startDecorator={<PencilSimple />}
            onClick={() => setIsEditOpen(true)}
          />
        )}
      </Stack>

      {isDtdProject && <MainInfo project={project} />}

      {!isDtdProject && (
        <Grid
          container
          spacing={3}
          sx={{ marginLeft: '-12px !important', marginRight: '-12px !important' }}
        >
          <Grid xs={12} md={6} lg={6}>
            <Stack sx={{ gap: '32px' }}>
              <MainInfo project={project} />
              <Location project={project} />
            </Stack>
          </Grid>

          <Grid xs={12} md={6} lg={6}>
            <Stack sx={{ gap: '32px' }}>
              <Duration project={project} />
              <PipelineInformation project={project} />
            </Stack>
          </Grid>
        </Grid>
      )}

      <UpsertProject isOpen={isEditOpen} onClose={() => setIsEditOpen(false)} project={project} />
    </Stack>
  );
};
